export default __webpack_public_path__ + "static/media/URF_logo.57c85767.png";